export default "__VITE_ASSET__uN8E4VQC__"